var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['icon-box', _vm.rounded && 'roundedIcon'],style:(_vm.getStyle)},[_c('v-icon',{attrs:{"x-large":"","color":_vm.colorHEX}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }